class EmailTemplateService {
    constructor($http, ICM_EMAIL_TEMPLATE_SERVICE_URL) {
        this.$http = $http;

        this.ICM_EMAIL_TEMPLATE_SERVICE_URL = ICM_EMAIL_TEMPLATE_SERVICE_URL;
        // we hold the templates here so we can communicate between the modal/other services and the table we also have to keep track of loading/empty states this way
        this.templates = [];
        // isLoadingTemplates for the empty state
        this.isLoadingTemplates = false;
        // loadingTemplatesPromise is for the table loader
        this.loadingTemplatesPromise = '';
        //call a functions to return things because you won't get updated values just referencing the variable (feel free to retest this though!)
        this.getIsLoadingTemplates = () => {
            return this.isLoadingTemplates;
        };
        this.getIsLoadingTemplatesPromise = () => {
            return this.loadingTemplatesPromise;
        };
        this.getTemplates = () => {
            return this.templates;
        };
    }

    createTemplate(templateName, templateBody) {
        const payload = {
            templateName: templateName || null,
            templateBody: templateBody || null
        };
        const url = this.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates';

        return this.$http.post(url, payload);
    }

    updateTemplate(templateId, templateName, templateBody) {
        let payload = {
            templateName: templateName,
            templateBody: templateBody
        };

        return this.$http.put(this.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates/' + templateId, payload);
    }

    getAllTemplatesByCompany() {
        this.isLoadingTemplates = true;
        this.loadingTemplatesPromise = new Promise((resolve, reject) => {
            this.getAllTemplates().then((response) => {
                this.templates = this.populateTemplateList(response.data.templates);
                this.isLoadingTemplates = false;
                resolve();
            }).catch((error) => {
                this.isLoadingTemplates = false;
                reject(error);
            });
        });
        return this.loadingTemplatesPromise;

    }

    getAllTemplates() {
        return this.$http.get(this.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates');
    }

    populateTemplateList(templateList) {
        return templateList.map((template) =>{
            return {
                id: template.id,
                title: template.name,
                createdOn: template.created_at,
                createdBy: `${template.created_by_first_name} ${template.created_by_last_name}`,
                updatedOn: template.updated_at,
                lastSent: template.last_sent_at
            };
        });
    }

    getTemplateById(id) {
        return new Promise((resolve, reject) => {
            this.$http.get(this.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates/' + id)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    populateTemplate(data) {
        return {
            id: data.id,
            title: data.name,
            body: data.body
        };
    }

    deleteTemplateById(id) {
        return new Promise((resolve, reject) => {
            this.$http.delete(this.ICM_EMAIL_TEMPLATE_SERVICE_URL + '/templates/' + id)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    deleteTemplateByIds(templateIds) {
        return new Promise((resolve, reject) => {
            this.$http.post(`${this.ICM_EMAIL_TEMPLATE_SERVICE_URL}/templates/bulkDelete`, {templateIds: templateIds})
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

angular.module('MW.Influencers.EmailTemplateService', [
        'Configuration'
    ])
    .service('EmailTemplateService', [
        '$http',
        'ICM_EMAIL_TEMPLATE_SERVICE_URL',
        EmailTemplateService
    ]);